import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericApiError } from '@/_shared/types/apiError';
import { GenericPut } from '@/_shared/types/swagger';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY } from '@/swagger/constants/slash-keys';
import { API_PUT_ASPECT_CALL, KEY_PUT_ASPECT_SAVE } from '../constants';
import { MOCK_RESPONSE_PUT_ASPECT_SAVE } from '../mocks';

export type RequestPutAspectSave = GenericPut<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONFIG_DESIGN_PATH_KEY
>['request']['body'];

export type CallParamsPutAspectSave = RequestPutAspectSave & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

const responseMapper = () => ({
  status: 'OK',
});

type CallResponsePutAspectSave = unknown;
type CallErrorPutAspectSave = GenericApiError;
type CallSelectorsPutAspectSave = unknown;

export const putAspectSaveCall = createGeneralCall<
  CallParamsPutAspectSave,
  CallResponsePutAspectSave,
  CallErrorPutAspectSave,
  CallSelectorsPutAspectSave
>({
  id: KEY_PUT_ASPECT_SAVE,
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_PUT_ASPECT_CALL(org as unknown as string);
  },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  method: 'put',
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_PUT_ASPECT_SAVE
    : undefined,
  responseMapper,
  responseExtractor: null,
});
